module.exports = __webpack_public_path__ + "static/img/list-item-1.ff66f0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/list-item-1.png
// module id = XhYQ
// module chunks = 1